import React, { useContext } from "react";
import { Box, Typography, Button, Paper, Link, Divider } from "@mui/material";
import {
  AccountCircle,
  Dashboard,
  Event,
  Link as LinkIcon,
  Login,
  TableRestaurant,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthProvider";
import Footer from "../components/Footer";
const Home = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleNavigation = () => {
    if (user?.role === "admin") {
      navigate("/dashboard");
    } else if (user?.role === "superadmin") {
      navigate("/superadmindashboard");
    } else {
      navigate("/login");
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "calc(100vh - 120px)",
          p: 3,
          textAlign: "center",
          bgcolor: "background.default",
          color: "text.primary",
        }}
      >
        {/* Welcome Section */}
        <Typography
          variant="h3"
          gutterBottom
          sx={{
            background: "linear-gradient(90deg, #0b3954, #087e8b)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontWeight: "bold",
          }}
        >
          Welcome to EventPass
        </Typography>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ color: "text.primary", mb: 4 }}
        >
          Your all-in-one platform for seamless event check-ins and management,
          powered by{" "}
          <Link
            href="https://www.whitewall.om/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "inherit", fontWeight: "bold" }}
          >
            WhiteWall Digital Solutions
          </Link>
          . <br />
          Get started today to manage events professionally and efficiently.
        </Typography>

        {/* Features Section */}
        <Paper
          elevation={6}
          sx={{
            p: 4,
            width: "100%",
            maxWidth: "800px",
            borderRadius: 3,
            textAlign: "left",
          }}
        >
          {[
            {
              icon: (
                <AccountCircle sx={{ fontSize: 40, color: "primary.main" }} />
              ),
              title: "Register as an Admin",
              description:
                "Sign up to create and manage events with advanced check-in features.",
            },
            {
              icon: <Dashboard sx={{ fontSize: 40, color: "primary.main" }} />,
              title: "Log in to the Dashboard",
              description:
                "Access your dashboard to create events and monitor attendee check-ins.",
            },
            {
              icon: <Event sx={{ fontSize: 40, color: "primary.main" }} />,
              title: "Organize Events",
              description:
                "Add event details and generate registration links instantly.",
            },
            {
              icon: <LinkIcon sx={{ fontSize: 40, color: "primary.main" }} />,
              title: "Share Registration Links",
              description:
                "Share links via social media or email for attendee sign-ups.",
            },
            {
              icon: (
                <TableRestaurant sx={{ fontSize: 40, color: "primary.main" }} />
              ),
              title: "Check In Attendees",
              description:
                "Use advanced check-in tools to assign tables and streamline event entry.",
            },
          ].map((step, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                mb: index < 4 ? 3 : 0,
              }}
            >
              {step.icon}
              <Box ml={2}>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  {step.title}
                </Typography>
                <Typography>{step.description}</Typography>
              </Box>
              {index < 4 && <Divider sx={{ my: 2 }} />}
            </Box>
          ))}
        </Paper>

        {/* Call to Action */}
        <Button
          onClick={handleNavigation}
          variant="contained"
          color="primary"
          size="large"
          startIcon={user ? <Dashboard /> : <Login />}
          sx={{
            mt: 5,
            px: 4,
            py: 1.5,
            fontWeight: "bold",
            borderRadius: 5,
          }}
        >
          {user ? "GO TO DASHBOARD" : "Log In"}
        </Button>
      </Box>
      <Footer></Footer>
    </>
  );
};

export default Home;
